module.exports = __webpack_public_path__ + "fontawesome-webfont.f775f9cca88e21d45beb.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/fontawesome-webfont.svg?v=4.5.0
// module id = ../../../../../resources/layout/fonts/fontawesome-webfont.svg?v=4.5.0
// module chunks = styles